if (!customElements.get('media-gallery')) {
  customElements.define('media-gallery', class MediaGallery extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        liveRegion: this.querySelector('[id^="GalleryStatus"]'),
        viewer: this.querySelector('[id^="GalleryViewer"]'),
        thumbnails: this.querySelector('[id^="GalleryThumbnails"]')
      }
      this.mql = window.matchMedia('(min-width: 750px)');
      if (!this.elements.thumbnails) return;

      this.elements.viewer.addEventListener('slideChanged', debounce(this.onSlideChanged.bind(this), 500));
      this.elements.thumbnails.querySelectorAll('[data-target]').forEach((mediaToSwitch) => {
        mediaToSwitch.querySelector('button').addEventListener('click', this.setActiveMedia.bind(this, mediaToSwitch.dataset.target, false));
      });
      if (this.dataset.desktopLayout.includes('thumbnail') && this.mql.matches) this.removeListSemantic();
    }

    onSlideChanged(event) {
      const thumbnail = this.elements.thumbnails.querySelector(`[data-target="${ event.detail.currentElement.dataset.mediaId }"]`);
      this.setActiveThumbnail(thumbnail);
      console.log("triggered")
      
    }

    setActiveMedia(mediaId, prepend = null, variant = null, modalContent = null) {
      document.getElementById("mediaLoader").classList.remove("hidden");
      
      let activeMedia = this.elements.viewer.querySelector(`[data-media-id="${ mediaId }"]`);
      
      if (variant != null && (variant.option1 || variant.option2) && this.elements.thumbnails){
        this.elements.thumbnails.querySelectorAll("li").forEach((element) => {
          if (variant.name.includes("Joggingbukser") || variant.name.includes("Sweatpants") || variant.name.includes("Jogging")  || variant.name.includes("Mjukisbyxor")){
            const variant1 = variant.option1.replace(/\s/g, '')
            const variant2 = variant.option2.replace(/\s/g, '')
            const elementValue = element.dataset.value.replace(/\s/g, '')

              if (elementValue.includes(variant1) && elementValue.includes(variant2)) {
                element.style.display = "list-item"
              } else {
                element.style.display = "none"
              }
          

          } else {

            var variant1 = variant.option1.replace(/\s/g, '').trim();
            
            const elementValue = element.dataset.value.replace(/\s/g, '').trim();

            console.log("variant1", variant1)
            console.log("elementValue", elementValue)

            if (variant1 == elementValue ) {
              element.style.display = "list-item"
            } else {
              element.style.display = "none"
            }
          }
          
        })

        document.querySelectorAll(".mobile-media-item").forEach((element) => {
          if (variant.name.includes("Joggingbukser") || variant.name.includes("Sweatpants") || variant.name.includes("Jogging") || variant.name.includes("Mjukisbyxor")){

            const variant1 = variant.option1.replace(/\s/g, '')
            const variant2 = variant.option2.replace(/\s/g, '')
            const elementValue = element.dataset.value.replace(/\s/g, '')

              if (elementValue.includes(variant1) && elementValue.includes(variant2)) {
                element.classList.remove("hide-mobile-media-item")
                element.classList.add("show-mobile-media-item")
              } else {
                element.classList.remove("show-mobile-media-item")
                element.classList.add("hide-mobile-media-item")
              }
            
          } else {

            var variant1 = variant.option1.replace(/\s/g, '').trim();

            const elementValue = element.dataset.value.replace(/\s/g, '').trim();

            console.log("variant1", variant1)
            console.log("elementValue", elementValue)

              if (variant1 == elementValue) {
                if (!activeMedia) {
                  activeMedia = element
                }
                element.classList.remove("hide-mobile-media-item")
                element.classList.add("show-mobile-media-item")
              } else {
                element.classList.remove("show-mobile-media-item")
                element.classList.add("hide-mobile-media-item")
              }
  
          }
          
        })
      } 

      if (!activeMedia) return 

      if (!mediaId) {
        var mediaId = activeMedia.dataset.mediaId;
      }

      if (activeMedia) {
        this.elements.viewer.querySelectorAll('[data-media-id]').forEach((element) => {
          element.classList.remove('is-active');
        });
        activeMedia.classList.add('is-active');
      }

      if (modalContent){
        const newMediaModal = modalContent.querySelector( `[data-media-id="${mediaId}"]`);
        modalContent.prepend(newMediaModal);
      }

      if (prepend) {
        activeMedia.parentElement.prepend(activeMedia);
        if (this.elements.thumbnails) {
          const activeThumbnail = this.elements.thumbnails.querySelector(`[data-target="${ mediaId }"]`);
          activeThumbnail.parentElement.prepend(activeThumbnail);
        }
        if (this.elements.viewer.slider) this.elements.viewer.resetPages();
      }

      this.preventStickyHeader();
      // prevent scroll on variant
      window.setTimeout(() => {
       if (this.elements.thumbnails) {
         activeMedia.parentElement.scrollTo({ left: activeMedia.offsetLeft });
       }
       if (!this.elements.thumbnails || this.dataset.desktopLayout === 'stacked') {
         activeMedia.scrollIntoView({behavior: 'smooth'});
       }
      });
      this.playActiveMedia(activeMedia);

      if (!this.elements.thumbnails) return;
      const activeThumbnail = this.elements.thumbnails.querySelector(`[data-target="${ mediaId }"]`);
      const activeThumbnailImg = activeThumbnail?.querySelector("img");

      if (activeThumbnailImg == null) return;      

      this.setActiveThumbnail(activeThumbnail);
      this.announceLiveRegion(activeMedia, activeThumbnail.dataset.mediaPosition);

      const activeImage = activeMedia.querySelector('img');
      activeImage.addEventListener('load', () => {
        document.getElementById("mediaLoader").classList.add("hidden");
      });
      
    }

    setActiveThumbnail(thumbnail) {
      if (!this.elements.thumbnails || !thumbnail) return;

      this.elements.thumbnails.querySelectorAll('button').forEach((element) => element.removeAttribute('aria-current'));
      thumbnail.querySelector('button').setAttribute('aria-current', true);
      if (this.elements.thumbnails.isSlideVisible(thumbnail, 10)) return;

      this.elements.thumbnails.slider.scrollTo({ left: thumbnail.offsetLeft });
    }

    announceLiveRegion(activeItem, position) {
      const image = activeItem.querySelector('.product__modal-opener--image img');
      if (!image) return;
      image.onload = () => {
        this.elements.liveRegion.setAttribute('aria-hidden', false);
        this.elements.liveRegion.innerHTML = window.accessibilityStrings.imageAvailable.replace(
          '[index]',
          position
        );
        setTimeout(() => {
          this.elements.liveRegion.setAttribute('aria-hidden', true);
        }, 2000);
      };
      image.src = image.src;
    }

    playActiveMedia(activeItem) {
      window.pauseAllMedia();
      const deferredMedia = activeItem.querySelector('.deferred-media');
      if (deferredMedia) deferredMedia.loadContent(false);
    }

    preventStickyHeader() {
      this.stickyHeader = this.stickyHeader || document.querySelector('sticky-header');
      if (!this.stickyHeader) return;
      this.stickyHeader.dispatchEvent(new Event('preventHeaderReveal'));
    }

    removeListSemantic() {
      if (!this.elements.viewer.slider) return;
      this.elements.viewer.slider.setAttribute('role', 'presentation');
      this.elements.viewer.sliderItems.forEach(slide => slide.setAttribute('role', 'presentation'));
    }
  });
}
